import { render, staticRenderFns } from "./WorkplaceHeaderButtons.vue?vue&type=template&id=06751b5c&"
import script from "./WorkplaceHeaderButtons.vue?vue&type=script&lang=js&"
export * from "./WorkplaceHeaderButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports